import React from 'react'
import type { LucideIcon as LucideIconType } from 'lucide-react'

interface LucideIconProps {
  icon: LucideIconType
  size?: number
  className?: string
}

// Forwards `className`: antd clones elements passed via an `icon` prop (e.g. Menu items) and
// injects its own spacing/state classes directly onto them - dropping it here would silently
// break that (e.g. the icon-to-label gap in a Dropdown menu).
const LucideIcon: React.FC<LucideIconProps> = ({ icon: IconComponent, size = 14, className }) => (
  <IconComponent size={size} className={className} style={{ verticalAlign: '-0.125em', lineHeight: 0, opacity: 0.6 }} />
)

export default LucideIcon
